import { isNil, sortBy } from 'lodash';

type ScrollOptions = {
  top?: number | undefined;
  left?: number | undefined;
  behavior?: 'auto' | 'smooth';
};

type ScrollTarget = {
  element: HTMLElement | null;
  offsetTop?: number;
  top?: number;
};

const windowScroll = (options: ScrollOptions): void => {
  if (typeof window !== 'undefined') {
    window.scroll(options);
  }
};

const getElementsByIds = (ids: string[]): ScrollTarget[] =>
  ids.map((id) => {
    const element = document.getElementById(id);
    const top = element?.getBoundingClientRect()?.top;
    return { element, offsetTop: element?.offsetTop, top };
  });

const scrollToElement = (element: HTMLElement | null, offset = -150): void => {
  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

// sometimes. offsetTop is not reliably available, so we can use top
export const scrollToFirstElement = (
  ids: string[],
  sortKey: 'offsetTop' | 'top' = 'offsetTop'
): void => {
  const elements = getElementsByIds(ids).filter((element) => !isNil(element[sortKey]));
  const sorted = sortBy(elements, [sortKey]);
  scrollToElement(sorted[0]?.element ?? null);
};

export default windowScroll;
